import React, { useContext } from "react";

import { observer } from "mobx-react";
import PropTypes from "prop-types";

import ComponentContext from "../../../contexts/ComponentContext";
import { hoursTypeMap } from "../../helpers/vacancyHelpers";
import VacancyImage from "../SearchResults/VacancyImage";

function VacancyWithIconsHead(props) {
  const { vacancy, category, thumbnailUrl, isForm, hideImage } = props;

  const Head = isForm ? "h2" : "h1";
  const { cityInTitle, showCloseDate, additionalConfig } =
    useContext(ComponentContext);

  let titleText = vacancy.title || vacancy.jobTitle;

  if (vacancy?.location?.city && cityInTitle) {
    titleText = `${vacancy?.location?.city} - ${vacancy.jobTitle}`;
  }

  let endDate = vacancy?.endDate;

  if (endDate) {
    const dateObject = new Date(endDate);

    // Checking if the date is valid
    if (!Number.isNaN(dateObject.getTime())) {
      endDate = dateObject.toLocaleDateString();
    } else {
      endDate = undefined;
    }
  }

  return (
    <div className="d-flex flex-grow-1">
      {hideImage ? null : (
        <VacancyImage
          imageUrl={vacancy?.company?.logoUrlFull || thumbnailUrl}
        />
      )}
      <div className="me-auto pe-3">
        <div className="d-flex gap-2">
          {additionalConfig?.showHeaderCategory ? (
            <div className="vacancy-role-card">{category}</div>
          ) : null}
        </div>
        <Head className="fw-bold vacancy-heading mb-1">{titleText}</Head>
        <div className="vacancy-description">
          <div className="mt-3 text-light d-flex flex-column gap-2">
            <div className="d-flex gap-3">
              <span className="vacancy-details d-flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  className="me-1"
                >
                  <path
                    d="M9.7249 3.60001C9.30719 3.60001 8.90658 3.78965 8.61121 4.12721C8.31584 4.46478 8.1499 4.92262 8.1499 5.40001V6.00001H4.4749C4.05719 6.00001 3.65658 6.18965 3.36121 6.52721C3.06584 6.86478 2.8999 7.32262 2.8999 7.80001V9.46081L10.8946 11.8968C11.1602 11.9776 11.4396 11.9776 11.7052 11.8968L19.6999 9.46081V7.80001C19.6999 7.32262 19.534 6.86478 19.2386 6.52721C18.9432 6.18965 18.5426 6.00001 18.1249 6.00001H14.4499V5.40001C14.4499 4.92262 14.284 4.46478 13.9886 4.12721C13.6932 3.78965 13.2926 3.60001 12.8749 3.60001H9.7249ZM9.7249 4.80001H12.8749C13.0141 4.80001 13.1477 4.86322 13.2461 4.97574C13.3446 5.08826 13.3999 5.24088 13.3999 5.40001V6.00001H9.1999V5.40001C9.1999 5.24088 9.25521 5.08826 9.35367 4.97574C9.45213 4.86322 9.58566 4.80001 9.7249 4.80001Z"
                    fill="#E4A951"
                  />
                  <path
                    d="M2.8999 17.4001C2.8999 17.8775 3.06584 18.3354 3.36121 18.6729C3.65658 19.0105 4.05719 19.2001 4.4749 19.2001H18.1249C18.5426 19.2001 18.9432 19.0105 19.2386 18.6729C19.534 18.3354 19.6999 17.8775 19.6999 17.4001V10.6201L11.4354 13.1365C11.3466 13.1636 11.2532 13.1636 11.1645 13.1365L2.8999 10.6201V17.4001Z"
                    fill="#E4A951"
                  />
                </svg>
                <span className="m-auto">
                  {hoursTypeMap[vacancy?.hoursType]}
                </span>
                <br />
              </span>
              <span className="location-city d-flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                  className="me-1"
                >
                  <path
                    d="M13 3.60001C9.41586 3.60001 6.5 6.51587 6.5 10.0999C6.5 14.5479 12.3168 21.0777 12.5645 21.3535C12.7971 21.6126 13.2032 21.6121 13.4354 21.3535C13.6831 21.0777 19.4999 14.5479 19.4999 10.0999C19.4998 6.51587 16.584 3.60001 13 3.60001ZM13 13.3702C11.1967 13.3702 9.7297 11.9032 9.7297 10.0999C9.7297 8.29668 11.1967 6.82967 13 6.82967C14.8032 6.82967 16.2702 8.29671 16.2702 10.1C16.2702 11.9032 14.8032 13.3702 13 13.3702Z"
                    fill="#E4A951"
                  />
                </svg>
                <span className="m-auto">{vacancy.location?.city}</span>
              </span>
              <span className="vacancy-details d-flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 22"
                  fill="none"
                  className="mt-auto me-1"
                >
                  <path
                    d="M12.5 2.5C7.52991 2.5 3.5 6.52991 3.5 11.5C3.5 16.4701 7.52991 20.5 12.5 20.5C17.4701 20.5 21.5 16.4701 21.5 11.5C21.5 6.52991 17.4701 2.5 12.5 2.5ZM15.433 15.7188C15.433 15.8071 15.3607 15.8795 15.2723 15.8795H9.77188C9.68348 15.8795 9.61116 15.8071 9.61116 15.7188V14.9453C9.61116 14.871 9.66138 14.8067 9.73371 14.7886C10.6176 14.5696 11.1962 13.8042 11.1962 12.8962C11.1962 12.6009 11.146 12.3056 11.0777 12.0083H9.72768C9.63929 12.0083 9.56696 11.9359 9.56696 11.8475V11.2449C9.56696 11.1565 9.63929 11.0842 9.72768 11.0842H10.8065C10.6498 10.5799 10.5132 10.0656 10.5132 9.53527C10.5132 8.0125 11.6904 7.11853 13.5567 7.11853C14.0891 7.11853 14.5893 7.22902 14.969 7.37366C15.0312 7.39777 15.0734 7.45804 15.0734 7.52433V8.31786C15.0735 8.34351 15.0675 8.36881 15.0558 8.39165C15.0442 8.41449 15.0272 8.43421 15.0064 8.44916C14.9855 8.4641 14.9614 8.47384 14.936 8.47756C14.9106 8.48128 14.8847 8.47887 14.8605 8.47054C14.5009 8.34196 14.077 8.2596 13.6471 8.2596C12.5763 8.2596 11.8933 8.79397 11.8933 9.66987C11.8933 10.1661 12.0179 10.6321 12.1625 11.0862H14.4125C14.5009 11.0862 14.5732 11.1585 14.5732 11.2469V11.8496C14.5732 11.9379 14.5009 12.0103 14.4125 12.0103H12.4317C12.494 12.2754 12.5382 12.5507 12.5382 12.8339C12.5382 13.6516 12.2067 14.3185 11.6562 14.6641V14.7585H15.2723C15.3607 14.7585 15.433 14.8308 15.433 14.9192V15.7188Z"
                    fill="#E4A951"
                  />
                </svg>
                <span className="m-auto">
                  {vacancy.remuneration?.description}
                </span>
              </span>
            </div>
          </div>
          {showCloseDate && endDate ? (
            <div className="pt-3 close-date fw-bold">Close date: {endDate}</div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default observer(VacancyWithIconsHead);

VacancyWithIconsHead.propTypes = {
  hideImage: PropTypes.bool,
  isForm: PropTypes.bool,
  thumbnailUrl: PropTypes.string,
  category: PropTypes.string,
  vacancy: PropTypes.shape({
    contractType: PropTypes.string,
    hoursType: PropTypes.string,
    location: PropTypes.shape({ city: PropTypes.string }),
    remuneration: PropTypes.shape({
      description: PropTypes.string,
    }),
    title: PropTypes.string,
  }),
};

VacancyWithIconsHead.defaultProps = {
  hideImage: false,
  isForm: false,
  thumbnailUrl: null,
  vacancy: null,
  category: null,
};
